function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
/*
 * A state machine for tracking Shiny output progress.
 *
 * Although there are a handful of possible states, the ultimate goal here is to
 * be able to say whether a given output `isRecalculating()` or not (and thus,
 * whether we should show progress indication or not).
 *
 * The diagram below depicts the state machine. Each node represents a possible
 * state and each edge represents a server-->client message that moves outputs
 * from one state to another. If a node name is all caps, then the output should
 * be showing a busy state when visible (i.e., `binding.showProgress(true)`).
 *
 * A more polished SVG version of this diagram can be found here:
 * https://github.com/rstudio/shiny/blob/main/inst/diagrams/outputProgressStateMachine.svg
 *
 * +---------+ recalculating  +---------+
 * | INITIAL +--------------->| RUNNING |<----------------+
 * +---------+                +---+-----+                 |
 *               +-----------/     |                      |
 *               |              recalculated              |
 *               |                 |                      |
 *               |              +--v---+---------------+  |
 *               |           +--+ IDLE +--+-------+    |  |
 *               |           |  +------+  |       |    |  |
 *             1 |          2|           3|      4|    |  |
 *               v           v            v       v    |  |
 *          +------------+ +------+  +-----+   +-----+ |  |
 *          | PERSISTENT | |cancel|  |value|   |error| |  |
 *          +-------+----+ +---+--+  +-+---+   +-+---+ |  |
 *                  |         5|      5|         |     |  |
 *                 5|          v       v        5|     |  |
 *                  |       +-------------+      |     |  |
 *                  +------>| INVALIDATED |<-----+     |  |
 *                          +-----+-------+<-----------+  |
 *                                |                       |
 *                                |    recalculating      |
 *                                +-----------------------+
 *
 *  1. {progress: {type: "binding", message: {persistent: true}}}
 *  2. No message
 *  3. Value
 *  4. Error
 *  5. {progress: {type: "binding"}}
 */
// The possible states of a given output.
var OutputStates; // Server->client messages that have an impact on output progress state.
// These derive from the Session's defineOutput() method.
(function (OutputStates) {
  OutputStates["Initial"] = "initial";
  OutputStates["Running"] = "running";
  OutputStates["Idle"] = "idle";
  OutputStates["Value"] = "value";
  OutputStates["Error"] = "error";
  OutputStates["Cancel"] = "cancel";
  OutputStates["Persistent"] = "persistent";
  OutputStates["Invalidated"] = "invalidated";
})(OutputStates || (OutputStates = {}));
var _updateStateFromRecalculating = /*#__PURE__*/new WeakSet();
var _updateStateFromFlush = /*#__PURE__*/new WeakSet();
var _updateStateFromProgress = /*#__PURE__*/new WeakSet();
var _updateStateFromValueOrError = /*#__PURE__*/new WeakSet();
var _getState = /*#__PURE__*/new WeakSet();
var _setState = /*#__PURE__*/new WeakSet();
// The state machine that tracks the progress of outputs in a Shiny app.
var OutputProgressReporter = /*#__PURE__*/function () {
  function OutputProgressReporter() {
    _classCallCheck(this, OutputProgressReporter);
    _classPrivateMethodInitSpec(this, _setState);
    _classPrivateMethodInitSpec(this, _getState);
    // When receiving values/errors as part of a flush message, outputs should generally
    // be moving from Idle to Value/Error state.
    _classPrivateMethodInitSpec(this, _updateStateFromValueOrError);
    _classPrivateMethodInitSpec(this, _updateStateFromProgress);
    _classPrivateMethodInitSpec(this, _updateStateFromFlush);
    _classPrivateMethodInitSpec(this, _updateStateFromRecalculating);
    _defineProperty(this, "outputStates", new Map());
    // A map of outputs that have changed their progress status since the last call to takeChanges().
    // The value is true if the output is recalculating, and false otherwise.
    _defineProperty(this, "changedOutputs", new Map());
  }
  _createClass(OutputProgressReporter, [{
    key: "takeChanges",
    value: function takeChanges() {
      var result = this.changedOutputs;
      this.changedOutputs = new Map();
      return result;
    }

    // Returns whether the output is recalculating or not.
  }, {
    key: "isRecalculating",
    value: function isRecalculating(name) {
      var state = _classPrivateMethodGet(this, _getState, _getState2).call(this, name);

      // The blue nodes in the state machine diagram
      var recalculatingStates = [OutputStates.Initial, OutputStates.Running, OutputStates.Idle, OutputStates.Persistent, OutputStates.Invalidated];
      return recalculatingStates.includes(state);
    }

    // Update output state based on the message received from the server.
    // Note that any message can be passed to this method, but only the
    // messages that are relevant to output progress do anything to the state.
  }, {
    key: "updateStateFromMessage",
    value: function updateStateFromMessage(message) {
      if (isRecalculatingMessage(message)) {
        // The "1st level" of the state machine diagram
        _classPrivateMethodGet(this, _updateStateFromRecalculating, _updateStateFromRecalculating2).call(this, message);
      }
      if (isFlushMessage(message)) {
        // The "2nd level" of the state machine diagram
        _classPrivateMethodGet(this, _updateStateFromFlush, _updateStateFromFlush2).call(this, message);
      }
      if (isProgressMessage(message)) {
        // The "3rd level" of the state machine diagram
        _classPrivateMethodGet(this, _updateStateFromProgress, _updateStateFromProgress2).call(this, message);
      }
    }
  }]);
  return OutputProgressReporter;
}(); // Type guards
function _updateStateFromRecalculating2(message) {
  var _message$recalculatin = message.recalculating,
    name = _message$recalculatin.name,
    status = _message$recalculatin.status;
  var state = _classPrivateMethodGet(this, _getState, _getState2).call(this, name);
  if (status === "recalculating") {
    switch (state) {
      case OutputStates.Initial:
      case OutputStates.Invalidated:
        _classPrivateMethodGet(this, _setState, _setState2).call(this, name, OutputStates.Running);
        break;
      default:
        throw new Error("Shiny server sent a message that the output '".concat(name, "' is recalculating,\n            but the output is in an unexpected state of: '").concat(state, "'."));
    }
  }
  if (status === "recalculated") {
    switch (state) {
      case OutputStates.Running:
        _classPrivateMethodGet(this, _setState, _setState2).call(this, name, OutputStates.Idle);
        break;
      default:
        throw new Error("Shiny server sent a message that the output '".concat(name, "' has been recalculated,\n            but the output is in an unexpected state of: '").concat(state, "'."));
    }
  }
}
function _updateStateFromFlush2(message) {
  for (var name in message.values) {
    _classPrivateMethodGet(this, _updateStateFromValueOrError, _updateStateFromValueOrError2).call(this, name, OutputStates.Value);
  }
  for (var _name in message.errors) {
    _classPrivateMethodGet(this, _updateStateFromValueOrError, _updateStateFromValueOrError2).call(this, _name, OutputStates.Error);
  }

  // Since req(F, cancelOutput = TRUE) doesn't send a message, we need to identify
  // the situation by looking for outputs that are still idle and move them to cancel.
  var _iterator = _createForOfIteratorHelper(this.outputStates),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        _name2 = _step$value[0],
        state = _step$value[1];
      switch (state) {
        case OutputStates.Idle:
          _classPrivateMethodGet(this, _setState, _setState2).call(this, _name2, OutputStates.Cancel);
          break;
        case OutputStates.Value:
        case OutputStates.Error:
        case OutputStates.Cancel:
        case OutputStates.Persistent:
        case OutputStates.Invalidated:
          // If the output is suspended
          break;
        default:
          throw new Error("Shiny server sent a flush message, and after processing the values and errors,\n            the output '".concat(_name2, "' has an unexpected ending state of: '").concat(state, "'."));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function _updateStateFromProgress2(message) {
  var _message$progress$mes = message.progress.message,
    id = _message$progress$mes.id,
    persistent = _message$progress$mes.persistent;
  var state = _classPrivateMethodGet(this, _getState, _getState2).call(this, id);
  if (persistent) {
    switch (state) {
      case OutputStates.Running:
        _classPrivateMethodGet(this, _setState, _setState2).call(this, id, OutputStates.Persistent);
        break;
      default:
        throw new Error("Shiny server has sent a 'persistent progress' message for ".concat(id, ",\n            but the output is in an unexpected state of: ").concat(state));
    }
  } else {
    switch (state) {
      case OutputStates.Value:
      case OutputStates.Error:
      case OutputStates.Cancel:
      case OutputStates.Persistent:
      case OutputStates.Idle:
        _classPrivateMethodGet(this, _setState, _setState2).call(this, id, OutputStates.Invalidated);
        break;
      default:
        throw new Error("Shiny server has sent a progress message for ".concat(id, ",\n            but the output is in an unexpected state of: ").concat(state));
    }
  }
}
function _updateStateFromValueOrError2(name, type) {
  var state = _classPrivateMethodGet(this, _getState, _getState2).call(this, name);
  switch (state) {
    case OutputStates.Idle:
      _classPrivateMethodGet(this, _setState, _setState2).call(this, name, type);
      break;
    default:
      throw new Error("Shiny server has sent a ".concat(type, " for the output '").concat(name, "',\n          but the output is in an unexpected state of: '").concat(state, "'."));
  }
}
function _getState2(name) {
  var _this$outputStates$ge;
  return (_this$outputStates$ge = this.outputStates.get(name)) !== null && _this$outputStates$ge !== void 0 ? _this$outputStates$ge : OutputStates.Initial;
}
function _setState2(name, state) {
  var oldRecalc = this.isRecalculating(name);
  this.outputStates.set(name, state);
  var newRecalc = this.isRecalculating(name);
  if (oldRecalc !== newRecalc) {
    this.changedOutputs.set(name, newRecalc);
  }
}
function isRecalculatingMessage(x) {
  var m = x;
  return m.recalculating !== undefined;
}
function isFlushMessage(x) {
  var m = x;
  return m.values !== undefined && m.errors !== undefined;
}
function isProgressMessage(x) {
  var m = x;
  return m.progress !== undefined && m.progress.type === "binding";
}
export { OutputProgressReporter };